<template lang="html">
  <div
    :class="[
      'ms-col',
      'ms-xs-'+msXs,
      'ms-sm-'+msSm,
      'ms-lg-'+msLg,
    ]"

    :style="{
      'order':msOrder,
      'justify-content':msJustify,
      'display':msType,
      'align-items':msAlign,
      'margin-left': getOffset,
      'width': getWidth,
      }"
    v-bind="$attrs">
    <slot/>
  </div>
</template>

<script>
  export default {
    name: 'MsCol',
    props: {
      lineHeight: {
        type: [Number, String],
        default: 12,
      },
      msW: {
        type: [Number, String],
        default: 12,
      },
      msXs: {
        type: [Number, String],
        default: ''
      },
      msSm: {
        type: [Number, String],
        default: ''
      },
      msLg: {
        type: [Number, String],
        default: ''
      },
      msOffset: {
        type: [Number, String],
        default: 0
      },
      msType: {
        type: String,
        default: null,
      },
      msJustify: {
        type: String,
        default: null,
      },
      msAlign: {
        type: String,
        default: null,
      },
      msOrder: {
        default: null,
        type: [String, Number]
      }
    },
    computed: {
      getOffset() {
        return this.msOffset*100/12+'%';
      },
      getWidth() {
        return this.msW*100/12+'%';
      }
    }
  }
</script>

<style lang="scss">
  .ms-col {
    float: left;
  }
  .ms-col label {
    color: #212121;
  }

  .ms-lg-12 {
    width: 100% !important;
  }

  .ms-lg-11 {
    width: 91.66666666666667% !important;
  }

  .ms-lg-10 {
    width: 83.33333333333333% !important;
  }

  .ms-lg-9 {
    width: 75% !important;
  }

  .ms-lg-8 {
    width: 66.66666666666667% !important;
  }

  .ms-lg-7 {
    width: 58.33333333333333% !important;
  }

  .ms-lg-6 {
    width: 50% !important;
  }

  .ms-lg-5 {
    width: 41.66666666666667% !important;
  }

  .ms-lg-4 {
    width: 33.33333333333333% !important;
  }

  .ms-lg-3 {
    width: 25% !important;
  }

  .ms-lg-2 {
    width: 16.66666666666667% !important;
  }

  .ms-lg-1 {
    width: 8.333333333333333% !important;
  }

  .ms-lg-0 {
    display: none !important;
  }

  @media only screen and (max-width: 900px) {
    .ms-sm-12 {
      width: 100% !important;
    }

    .ms-sm-11 {
      width: 91.66666666666667% !important;
    }

    .ms-sm-10 {
      width: 83.33333333333333% !important;
    }

    .ms-sm-9 {
      width: 75% !important;
    }

    .ms-sm-8 {
      width: 66.66666666666667% !important;
    }

    .ms-sm-7 {
      width: 58.33333333333333% !important;
    }

    .ms-sm-6 {
      width: 50% !important;
    }

    .ms-sm-5 {
      width: 41.66666666666667% !important;
    }

    .ms-sm-4 {
      width: 33.33333333333333% !important;
    }

    .ms-sm-3 {
      width: 25% !important;
    }

    .ms-sm-2 {
      width: 16.66666666666667% !important;
    }

    .ms-sm-1 {
      width: 8.333333333333333% !important;
    }

    .ms-sm-0 {
      display: none !important;
    }
  }

  @media only screen and (max-width: 600px) {
    .ms-xs-12 {
      width: 100% !important;
    }

    .ms-xs-11 {
      width: 91.66666666666667% !important;
    }

    .ms-xs-10 {
      width: 83.33333333333333% !important;
    }

    .ms-xs-9 {
      width: 75% !important;
    }

    .ms-xs-8 {
      width: 66.66666666666667% !important;
    }

    .ms-xs-7 {
      width: 58.33333333333333% !important;
    }

    .ms-xs-6 {
      width: 50% !important;
    }

    .ms-xs-5 {
      width: 41.66666666666667% !important;
    }

    .ms-xs-4 {
      width: 33.33333333333333% !important;
    }

    .ms-xs-3 {
      width: 25% !important;
    }

    .ms-xs-2 {
      width: 16.66666666666667% !important;
    }

    .ms-xs-1 {
      width: 8.333333333333333% !important;
    }

    .ms-xs-0 {
      display: none !important;
    }
  }


</style>
